import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userService from "../services/userService";

export const userListResponce = createAsyncThunk("user/list", async (data) => {
  const res = await userService.getUser(data);
  return res?.data;
});

export const deleteUserResponce = createAsyncThunk(
  "user/delete",
  async (id) => {
    const res = await userService.deleteUser(id);
    return res;
  }
);

export const enableDisbledUserResponce = createAsyncThunk(
  "driver/enable",
  async (data) => {
    const res = await userService.enableDisbledUser(data);
    return { res, params: data };
  }
);

export const currentBookingAction = createAsyncThunk(
  "user/currentBooking",
  async (id) => {
    const res = await userService.currentBooking(id);
    const transformedArray = res.data.map((item) => ({
      _id: item._id,
      image: item.eventDetails.image,
      title: item.eventDetails.title,
      location: item.eventDetails.location,
      startdatetime: item.eventDetails.startdatetime,
      enddatetime: item.eventDetails.enddatetime,
      artist: item.artistsDetails.map((artist) => ({
        id: artist._id,
        artistimage: artist.image,
        artistname: artist.name,
      })),
      eventstatus: item.eventDetails.eventstatus,
      isdelivery: item.isdelivery,
      ticketId: item?.ticketid ? item?.ticketid : "-",

      bookingtiming: item.orderstatustimestamp,
      ticketPrice: item.ticketprice,
      viewTicker: "View Ticket",
    }));
    return transformedArray;
  }
);

export const pastBookingAction = createAsyncThunk(
  "user/pastBooking",
  async (id) => {
    const res = await userService.pastBooking(id);

    const transformedArray = res.data.map((item) => ({
      _id: item._id,
      image: item.eventDetails.image,
      title: item.eventDetails.title,
      location: item.eventDetails.location,
      startdatetime: item.eventDetails.startdatetime,
      enddatetime: item.eventDetails.enddatetime,
      artist: item.artistsDetails.map((artist) => ({
        id: artist._id,
        artistimage: artist.image,
        artistname: artist.name,
      })),
      eventstatus: item.eventDetails.eventstatus,
      isdelivery: item.isdelivery,
      ticketId: item?.ticketid ? item?.ticketid : "-",
      bookingtiming: item.orderstatustimestamp,
      ticketPrice: item.ticketprice,
      viewTicker: "View Ticket",
    }));
    return transformedArray;
  }
);

/**
 * Creates a Redux slice for managing the 'events' state.
 * @param {object} config - The configuration object for creating the slice.
 * @param {string} config.name - The name of the slice.
 * @param {object} config.initialState - The initial state of the slice.
 * @param {array} config.initialState.genre - The initial value of the 'genre' property in the state.
 * @param {object} config.reducers - The reducer functions for updating the state.
 * @param {function} config.reducers.genreSuccess - The reducer function for updating the 'genre' property in the state when a genre is successfully fetched.
 * @param {function} config.reducers.deleteGenreSucesss
 */
const userSlice = createSlice({
  name: "users",
  initialState: {
    userResponce: [],
    deleteUserResponce: [],
    deleteUserError: "",
    enableDisbledDriverRes: [],
    enableDriverError: "",
    organiser: [],
    currentBookingResponse: [],
    currentBookingError: "",
    pastBookingResponse: [],
    pastBookingError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(userListResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(userListResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.userResponce = action.payload;
      })
      .addCase(userListResponce.rejected, (state) => {
        state.loading = false;
      });

    // delete
    builder
      .addCase(deleteUserResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUserResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteUserResponce = action.payload;
        state.userResponce = state.userResponce?.filter(
          (item) => item?._id !== action?.payload?.data?._id
        );
      })
      .addCase(deleteUserResponce.rejected, (state, action) => {
        state.loading = false;
        state.deleteUserError = action?.error;
      });

    // enbale-disbled
    builder
      .addCase(enableDisbledUserResponce.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(enableDisbledUserResponce.fulfilled, (state, action) => {
        state.isLoading = false;
        state.enableDisbledDriverRes = action.payload?.res;
        state.userResponce = state.userResponce.map((item) => {
          if (item._id === action.payload?.params?._id) {
            return { ...item, status: action.payload?.params?.status };
          }
          return item;
        });
      })
      .addCase(enableDisbledUserResponce.rejected, (state, action) => {
        state.isLoading = false;
        state.enableDriverError = action?.error;
      });

    //current booking
    builder
      .addCase(currentBookingAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(currentBookingAction.fulfilled, (state, action) => {
        state.loading = false;
        state.currentBookingResponse = action.payload;
      })
      .addCase(currentBookingAction.rejected, (state, action) => {
        state.loading = false;
        state.currentBookingError = action?.error;
      });

    //past booking
    builder
      .addCase(pastBookingAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(pastBookingAction.fulfilled, (state, action) => {
        state.loading = false;
        state.pastBookingResponse = action.payload;
      })
      .addCase(pastBookingAction.rejected, (state, action) => {
        state.pastBookingError = action?.error;
        state.loading = false;
      });
  },
});

export default userSlice.reducer;
